import us from './us';
import mx from './mx';
import {getState} from '../utils/store';

const languages = {
    us,
    mx
}

export default (path, params) => {
    const {app} = getState(),
          language = app.language || "us";

    let message = languages[language];

    // Language doesn't exist
    if(typeof message === 'undefined')
        return `${language}@${path}`;

    // Find message by path
    for(const p of path.split('.')) {
        if(typeof message[p] === 'undefined')
            return `${language}@${path}`;
        else
            message = message[p];
    }

    if(typeof message === 'function')
        return message(params);
    else
        return message;
}